import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client.js';

/**
 * The person's own scenes, newest first, for "Your scenes" and the pickers. The
 * API's list (GET /ai-agent/scenes) has what a tile and a picker need; until it is
 * live the project list stands in (it marks a scene and carries its poster, but
 * not its clip, length or shape).
 */
async function fetchScenes() {
  try {
    const answer = await api.listScenes();
    return (answer?.scenes || []).map((scene) => ({ status: 'completed', ...scene }));
  } catch {
    const answer = await api.getProjects({ page: 1, pageSize: 50, projectType: 'ai_agent' });
    return (answer?.projects || [])
      .filter((project) => project?.ai_agent_json?.kind === 'scene')
      .map((project) => ({
        id: project.id,
        title: project.title,
        poster_url: project.ai_agent_json?.thumbnail || null,
        status: String(project.status || '').toLowerCase(),
        progress: project.progress || 0,
        aspect_ratio: project.ai_agent_json?.aspect_ratio || '9:16',
        created_at: project.created_at,
      }));
  }
}

export default function useMyScenes({ enabled = true } = {}) {
  return useQuery({
    queryKey: ['my-scenes'],
    queryFn: fetchScenes,
    enabled,
    // One being made is asked about until it is done
    refetchInterval: (query) => ((query.state.data || []).some((scene) => scene.status === 'processing') ? 5000 : false),
  });
}
